module.exports = __webpack_public_path__ + "static/media/mapaNew.7856533c.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/img/mapaNew.png
// module id = 626
// module chunks = 0